import { Helmet } from 'react-helmet-async'

const SITE_URL = 'https://tilliopayment.com'
const SITE_NAME = 'Tillio POS'
const DEFAULT_IMAGE = `${SITE_URL}/hero-pos.webp`

export default function Seo({
  title,
  description,
  path = '/',
  image,
  type = 'website',
  jsonLd,
}) {
  const fullTitle = title.includes('Tillio') ? title : `${title} | Tillio POS`
  const url = `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`
  const ogImage = image
    ? image.startsWith('http')
      ? image
      : `${SITE_URL}${image.startsWith('/') ? image : `/${image}`}`
    : DEFAULT_IMAGE

  const schemas = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : []

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:alt" content={fullTitle} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  )
}

export { SITE_URL, SITE_NAME }
